<ng-container *ngIf="taskProcessPageFields">
  <ng-container *ngIf="taskProcessPageFields.user.length > 0">
    <div class="section-title">{{ 'm/custom-fields/user-section-title' | translate }}</div>
    <app-custom-field
      *ngFor="let field of taskProcessPageFields.user"
      [customField]="field"
      [customFieldFormGroup]="getUserFieldFormGroup(field)"></app-custom-field>
    <div *ngIf="!isUserReadOnly" class="buttons-container">
      <ion-button (click)="saveUserFields()" [disabled]="userFieldsFormGroup.pristine" fill="clear">{{
        'm/save' | translate
      }}</ion-button>
    </div>
  </ng-container>
  <ng-container *ngIf="taskProcessPageFields.conversation.length > 0">
    <div class="section-title">{{ 'm/custom-fields/conversation-section-title' | translate }}</div>
    <app-custom-field
      *ngFor="let field of taskProcessPageFields.conversation"
      [customField]="field"
      [customFieldFormGroup]="getConversationFieldFormGroup(field)"></app-custom-field>
    <div *ngIf="!isUserReadOnly" class="buttons-container">
      <ion-button (click)="saveConversationFields()" [disabled]="conversationFieldsFormGroup.pristine" fill="clear">{{
        'm/save' | translate
      }}</ion-button>
    </div>
  </ng-container>
</ng-container>
